module.exports = __webpack_public_path__ + "img/020086.be1c4ca9.png";